<script>

    import { createEventDispatcher } from 'svelte'
    import { push } from 'svelte-spa-router'
    import { toast } from 'bulma-toast'
    import { QuotationStore } from '../stores'

    import RequestsService from '../$services/requests.service'
    import NumeralMethods from '../$methods/numeral.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Switch from '../$components/switch.svelte'
    import InputText from '../$components/input.text.svelte'
    import Message from '../$components/message.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'
    import Value from '../$components/value.svelte'
    import Form from '../$components/form.svelte'

    import Merchandises from '../merchandises/merchandises.select.svelte'
    import ShipmentGuide from '../requests/shipment.guide.svelte'

    const dispatch = createEventDispatcher()

    export let pickup = {}
    export let delivery = {}
    export let pricing = {}

    let loading = false
    let data = {}
    let shipment = null

    async function createShipment() {

        data.pickup = pickup
        data.delivery = delivery
        data.token = pricing.token

        loading = true
        const resp = await RequestsService.createShipment(data)
        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: "is-danger" })

        shipment = resp.data
    }

</script>

{#if shipment}
    <ShipmentGuide {shipment} />
    <hr>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <div class="buttons">
                    <Button on:click={() => dispatch('reset')} text="Nuevo envío" icon="sync-alt" />
                    <Button on:click={() => push('#/shipments')} text="Ver envíos" icon="shipping-fast" color="primary" />
                </div>
            </div>
        </div>
    </div>
{/if}

{#if !shipment}
    <div class="title is-3">Origen</div>
    <hr>
    <div class="columns">
        <div class="column is-4">
            <Value label="Contacto" value={pickup.contact} />
        </div>
        <div class="column">
            <Value label="Dirección" value={`${pickup.street}, ${pickup.number}, ${pickup.colony}`} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Button on:click={() => dispatch('step', 'pickup')} text="Editar" icon="edit" color="primary" size="small" />
            </div>
        </div>
    </div>
    <br>
    <div class="title is-3">Destino</div>
    <hr>
    <div class="columns">
        <div class="column is-4">
            <Value label="Contacto" value={delivery.contact} />
        </div>
        <div class="column">
            <Value label="Dirección" value={`${delivery.street}, ${delivery.number}, ${delivery.colony}`} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Button on:click={() => dispatch('step', 'delivery')} text="Editar" icon="edit" color="primary" size="small" />
            </div>
        </div>
    </div>
    <br>
    <div class="title is-3">Paquete</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Ancho" value={$QuotationStore.package.width} postfix="CM" />
        </div>
        <div class="column">
            <Value label="Alto" value={$QuotationStore.package.height} postfix="CM" />
        </div>
        <div class="column">
            <Value label="Largo" value={$QuotationStore.package.length} postfix="CM" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Valor" value={NumeralMethods.cash($QuotationStore.package.value)}
            />
        </div>
        <div class="column">
            <Value label="Peso físico" value={$QuotationStore.package.weight} postfix="KG" />
        </div>
        <div class="column">
            <Value label="Volumétrico" value={$QuotationStore.package.volumetric} postfix="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Button on:click={() => dispatch('step', 'main')} text="Editar" icon="edit" color="primary" size="small" />
            </div>
        </div>
    </div>
    <br>
    <div class="title is-3">Servicio</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Proveedor" value={pricing.provider} />
        </div>
        <div class="column">
            <Value label="Service" value={pricing.service} />
        </div>
        <div class="column">
            <Value label="Tipo" value={EnumMethods.get(pricing.shipmentType)} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Precio de envío" value={NumeralMethods.cash(pricing.shipmentPrice)} />
        </div>
        <div class="column">
            <Value label="Precio de seguro" value={NumeralMethods.cash(pricing.insurancePrice)} />
        </div>
        <div class="column">
            <Value label="Precio final" value={NumeralMethods.cash(pricing.finalPrice)} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Tipo de pago" value={ EnumMethods.get(pricing.paymentType) } />
        </div>
        {#if pricing.paymentType === 'prepaid'}
            <div class="column">
                <Value label="Guías generadas" value={ pricing.prepaidCount } />
            </div>
            <div class="column">
                <Value label="Guías restantes" value={ pricing.prepaidTotal - pricing.prepaidCount } />
            </div>
        {/if}
    </div>
    {#if pricing.notes}
        <div class="columns">
            <div class="column">
                <Message message={ pricing.notes } color="warning" />
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Button on:click={() => dispatch('step', 'prices')} text="Editar" icon="edit" color="primary" size="small" />
            </div>
        </div>
    </div>
    <br>
    <div class="title is-3">Mercancias</div>
    <hr>
    <Merchandises bind:merchandises={data.merchandises} />
    <br>
    <div class="title is-3">Generar</div>
    <hr>
    <Form on:submit={createShipment} on:canceled={() => dispatch('step', 'delivery')} textSave="Confirmar" textCancel="Regresar" iconSave="check" iconCancel="chevron-left" {loading} >
        <div class="columns">
            <div class="column">
                <Switch bind:value={ data.isSecret } label="Generar código secreto" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.packageContent} label="Contenido" icon="box" placeholder="Descripción resumida del contenido del paquete" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.alias} label="Alias" icon="file-signature" placeholder="Alias" required={false} />
            </div>
            <div class="column">
                <Select bind:value={data.documentFormat} label="Formato" icon="file-pdf"
                    options={[
                        {value: 'pdf', text: 'PDF'},
                        {value: '6x4', text: 'Etiqueta'},
                    ]}
                />
            </div>
        </div>
    </Form>
{/if}